import React from 'react';
import { TChildren } from '../../../typings/common';
import styles from './ToolbarRight.module.scss';

interface Props {
  children: TChildren;
}

const ToolbarRight: React.FC<Props> = ({ children }) => (
  <div className={styles.toolbarRight}>{children}</div>
);

export default ToolbarRight;
